import React from 'react';

import { Flex, Text } from '@adsk/alloy-react-box';
import { LinkButton } from '@adsk/alloy-react-button';
import { AlertWarningIcon } from '@adsk/alloy-react-icon';
import ProgressRing from '@adsk/alloy-react-progress-ring';
import theme from '@adsk/alloy-react-theme';

import { useTranslation } from '../i18n';

const TableFooter = ({
  loading,
  error,
  onRetry,
  loadingMoreText,
  errorText,
}) => {
  const { t } = useTranslation();
  let footer = null;
  if (loading) {
    footer = (
      <>
        <ProgressRing size={ProgressRing.SIZES.SMALL} />
        <Text typography="bodySmall" color="charcoal700" marginLeft="13px">
          {loadingMoreText || t('LOADING_MORE')}
        </Text>
      </>
    );
  } else if (error) {
    footer = (
      <>
        <AlertWarningIcon
          style={{
            color: theme.colors.charcoal700,
          }}
        />
        <Text
          typography="bodySmall"
          color="charcoal700"
          marginLeft="12px"
          marginRight="8px"
        >
          {errorText || t('ERROR_LOADING_ALL_RESULTS')}
        </Text>
        <LinkButton onClick={onRetry} style={theme.typography.bodySmall}>
          {t('TRY_AGAIN')}
        </LinkButton>
      </>
    );
  }

  if (!footer) return null;

  return (
    <Flex alignItems="center" paddingLeft="50px" height="48px" flex="none">
      {footer}
    </Flex>
  );
};

export default TableFooter;
